export default __webpack_public_path__ + "img/206ea0e00264dbe556bbefe833ee4fe4.svg";